<template>
    <div>
        <div class="block-content block-content-full px-5 py-5 mb-0 mt-4">
            <div class="row">
                <div class="col-12 mb-4">
                    <span v-if="!editMode">
                        <h4 class="model-editor-name" @dblclick="openEditMode">
                            {{ designFilename }} &nbsp;
                            <i aria-hidden="true" class="fa fa-pencil-alt fa-2 mr-2" @click="openEditMode()"></i>
                        </h4>
                    </span>
                    <div v-else>
                        <div class="row">
                            <div class="col-11">
                                <input class="form-control" type="text" v-model="designFilename" @keyup.enter="openEditMode" />
                            </div>
                            <div class="col-1">
                                <button class="btn fs-xs btn-primary-icon px-4 rounded-8 fw-medium" v-on:click="openEditMode">
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M17 21V13H7V21"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M7 3V8H15"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EmailEditor
                ref="emailEditor"
                v-on:load="editorLoaded"
                :min-height="minHeight"
                :projectId="projectId"
                :locale="locale"
            />
            <div class="btns mt-3">
                <button
                    class="btn btn-primary-inverse btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                    :disabled="isLoadingSendTemplate"
                    @click="sendDesign"
                >
                    <span v-if="isLoadingSendTemplate">
                        <i class="fa fa-spinner fa-spin fa-fw"></i> {{ $t('common.loading') }}
                        <span class="sr-only">{{ $t('common.loading') }}</span>
                    </span>
                    <span v-else>
                        <i class="fas fa-save" :title="$t('common.save')"></i> {{ $t('marketing.campaigns.save_model') }}
                    </span>
                </button>
                <button
                    class="btn btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                    :disabled="isLoadingConfirmBtn"
                    @click="campaigneEmailConfirm"
                >
                    <span v-if="isLoadingConfirmBtn">
                        <i class="fa fa-spinner fa-spin fa-fw"></i> {{ $t('common.loading') }}
                        <span class="sr-only">{{ $t('common.loading') }}</span>
                    </span>
                    <span v-else> <i class="fas fa-check" :title="$t('common.validate')"></i> {{ $t('common.confirm') }} </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import ApiManagerCustomer from '../Customer/Api/ApiManagerBoCutomer.js'
import ApiManagerMarketing from './Api/ApiManagerMarketing.js'
// import { EmailEditor } from 'vue-email-editor'

const EmailEditor = defineAsyncComponent(() => import('vue-email-editor').then((module) => module.EmailEditor))

export default {
    name: 'MarketingCompaignEmailsIndex',
    props: ['file', 'url_btn_campaigne_email_create'],
    data: () => ({
        htmlContent: [],
        minHeight: '700px',
        locale: 'fr',
        projectId: 1,
        tools: {
            // disable image tool
            image: {
                enabled: true,
            },
        },
        options: {},
        appearance: {
            theme: 'light',
            panels: {
                tools: {
                    dock: 'right',
                },
            },
        },
        optionsString: {
            body: {
                rows: [],
            },
        },

        mode: 'light',
        result: '',

        isLoadingSendTemplate: false,
        showTooltipAddDesign: false,
        designFilename: '',
        editMode: false,
        isLoadingConfirmBtn: false,
    }),
    created() {
        this.designFilename = this.$t('marketing.campaigns.design_filename')
    },
    methods: {
        sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms))
        },

        editorLoaded() {
            this.$refs.emailEditor.editor.loadDesign(JSON.parse(this.file))
        },

        saveDesign() {
            this.designFilename = ''
            this.showTooltipAddDesign = true
        },

        async exportHtml() {
            this.$refs.emailEditor.editor.exportHtml((data) => {
                this.htmlContent = data.html ? data.html.replace(/\n/g, '') : data
            })
        },

        async fetchApplyFilters(params) {
            try {
                const result = await ApiManagerCustomer.fetchApplyFilters(params)
                this.applyedFiltersList = result?.userCustomFilter ?? []
                this.to = result?.customers.to ?? 0
                this.total = result?.customers.total ?? 0
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },

        openEditMode() {
            this.editMode = !this.editMode
        },

        async campaigneEmailConfirm() {
            const urlParams = new URLSearchParams(window.location.search)

            this.isLoadingConfirmBtn = true

            await this.exportHtml()
            await this.sleep(700)

            const payload = {
                uuid: urlParams.get('campaigne_email_uuid') || '',
                model: urlParams.get('model') || '',
                content: this.htmlContent,
            }

            try {
                const result = await ApiManagerMarketing.campaigneEmailsConfirm(payload)

                if (result.success) {
                    this.$toast.success(result?.message ?? this.$t('marketing.messages.operation_success'))
                    this.sleep(3500)
                    this.goToCreateCampaign(payload?.uuid)
                } else {
                    this.$toast.error(result?.message ?? this.$t('common.error_occurred'))
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.isLoadingConfirmBtn = false
            }
        },

        async saveEmailDesign(data) {
            this.isLoadingSendTemplate = true
            try {
                this.result = await ApiManagerCustomer.saveEmailDesign(data)
                if (this.result.success) {
                    this.$toast.success(this.result?.message ?? this.$t('marketing.messages.saved_success'))
                } else {
                    this.$toast.error(this.result?.message ?? this.$t('common.error_occurred'))
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.isLoadingSendTemplate = false
                this.showTooltipAddDesign = false
            }
        },

        sendDesign() {
            this.$refs.emailEditor.editor.saveDesign((design) => {
                this.saveEmailDesign({
                    content: design,
                    filename: this.designFilename,
                })
            })
        },

        goToCreateCampaign(uuid = '') {
            window.location.href =
                uuid === ''
                    ? this.url_btn_campaigne_email_create
                    : `${this.url_btn_campaigne_email_create}?campaigne_email_uuid=${uuid}`
        },
    },
    async mounted() {
        this.fetchApplyFilters({
            getCustomersEmails: false,
            perPage: this.limit,
            page: this.offset,
        })
    },
}
</script>

<style scoped>
.model-editor-name {
    line-height: 22px;
    font-weight: 500;
    margin-bottom: 10px;
}

.btn-primary-icon {
    color: #fff !important;
    background-color: #7d2dbd;
    border-color: #7d2dbd;
    height: 50px !important;
    line-height: 35px;
}
</style>
